import React from 'react';
import CarrierForm from './CarrierForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Carrier } from '../../../app/models/Carrier';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    Carrier: Carrier;
    setCarrier: (Carrier: Carrier) => void;
    errorFields?: any;
}

const CarrierFormContainer = ({
    fetching,
    action,
    cancel,
    Carrier,
    setCarrier,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <CarrierForm
                        carrier={Carrier}
                        setCarrier={setCarrier}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default CarrierFormContainer;
